import { apiFetch } from "./apiClient";

/** Contacto de la Agenda de contactos, antes "Agenda de maestros" (gasfíter, electricista, cerrajero, …). El tipo conserva el nombre técnico `Maestro`. */
export interface Maestro {
  id: number;
  nombre: string;
  /** @deprecated rubro único (legacy). Usar `rubros`. */
  rubro?: string | null;
  /** Rubros/oficios (varios) — nombres del catálogo tipo="rubro". */
  rubros?: string[];
  telefono?: string | null;
  email?: string | null;
  ubicacion?: string | null;
  caracteristicas?: string | null;
  notas?: string | null;
  /** Geografía estructurada (IDs + nombres resueltos por el backend). */
  region?: number | null;
  comuna?: number | null;
  sector?: number | null;
  regionNombre?: string | null;
  comunaNombre?: string | null;
  sectorNombre?: string | null;
  orden?: number;
  /** Adjuntos (metadatos). El detalle con URLs firmadas se trae por
   *  /agenda-contactos/:id/archivos (lo maneja AttachmentsManager). */
  archivos?: unknown[];
  created_at?: string;
  updated_at?: string;
}

export type MaestroCreate = {
  nombre: string;
  rubros?: string[];
  telefono?: string | null;
  email?: string | null;
  ubicacion?: string | null;
  caracteristicas?: string | null;
  notas?: string | null;
  region?: number | null;
  comuna?: number | null;
  sector?: number | null;
};

// Path canónico desde el renombre 2026-07-02 (el backend mantiene
// /api/agenda-maestros como alias legacy montando el mismo router).
const BASE = "/agenda-contactos";

export const agendaMaestrosApi = {
  list: (): Promise<{ success: boolean; data: Maestro[] } | null> =>
    apiFetch<{ success: boolean; data: Maestro[] }>(BASE, {
      errorMsg: "Error al cargar la agenda de contactos",
    }),

  create: (body: MaestroCreate): Promise<{ success: boolean; data: Maestro } | null> =>
    // Sin successMsg: la página muestra su propio toast accionable ("...ahora
    // puedes adjuntar archivos") tras crear, así no se duplican.
    apiFetch<{ success: boolean; data: Maestro }>(BASE, {
      method: "POST",
      body: JSON.stringify(body),
      errorMsg: "Error al crear el contacto",
    }),

  update: (
    id: number,
    body: Partial<MaestroCreate>,
  ): Promise<{ success: boolean; data: Maestro } | null> =>
    apiFetch<{ success: boolean; data: Maestro }>(`${BASE}/${id}`, {
      method: "PUT",
      body: JSON.stringify(body),
      successMsg: "Contacto actualizado",
      errorMsg: "Error al actualizar el contacto",
    }),

  remove: (id: number): Promise<{ success: boolean } | null> =>
    apiFetch<{ success: boolean }>(`${BASE}/${id}`, {
      method: "DELETE",
      successMsg: "Contacto eliminado",
      errorMsg: "Error al eliminar el contacto",
    }),

  reorder: (ids: number[]): Promise<{ success: boolean } | null> =>
    apiFetch<{ success: boolean }>(`${BASE}/reorder`, {
      method: "PUT",
      body: JSON.stringify({ ids }),
      errorMsg: "Error al reordenar",
    }),
};
